import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";

import { useNavigate } from "react-router";
import BasicLayout from "@/layouts/basic-layout";
import { ActionButton } from "@/dev/ui/verify-footer";

export default function ErrorPage({ error }: { error?: Error & { digest?: string } }) {
  const navigator = useNavigate();
  useEffect(() => {
    console.error(error);
  }, [error]);

  const reset = () => {
    // reload the  page
    window.location.reload();
  };
  const goHome = () => {
    // navigate to home page
    navigator("/", { replace: true });
    window.location.reload();
  };

  return (
    <BasicLayout>
      <main className="flex-grow  text-black">
        <div className="container mx-auto py-16 flex flex-col items-center justify-center">
          <AlertTriangle className="h-24 w-24 text-[#b65bf3] mb-6" />
          <h1 className="text-4xl font-bold mb-4">שגיאה</h1>
          <p dir="rtl" className="text-xl mb-8 text-center max-w-md">
            אירעה שגיאה בטעינת הדף. אנא נסה שוב מאוחר יותר או צור קשר עם התמיכה.
          </p>
          <div className="flex gap-4 space-x-4 sm:space-x-0">
            <ActionButton onClick={() => reset()}>נסה שוב</ActionButton>
            <ActionButton color="gray" onClick={goHome}>
              חזרה לדף הבית
            </ActionButton>
          </div>
        </div>
      </main>
    </BasicLayout>
  );
}
